import { InsuredProfileComponent } from '../insured-profile/insured-profile.component';
import { LatestActivitiesComponent } from '../latest-activities/latest-activities.component';
import { MoratoriumComponent } from '../moratorium/moratorium.component';
import { TransactionsInformationComponent } from '../transactions-information/transactions-information.component';
import { InspectionsComponent } from '../inspections/inspections.component';
import { RecentDocumentsComponent } from '../recent-documents/recent-documents.component';
import { InboundOutboundCommsComponent } from '../inbound-outbound-comms/inbound-outbound-comms.component';
import { NotesComponent } from '../notes/notes.component';
import { PolicyGeneralInformationComponent } from '../policy-general-information/policy-general-information.component';
import { BillingInformationComponent } from '../billing-information/billing-information.component';
import { PaymentInformationComponent } from '../payment-information/payment-information.component';
import { PolicyNumberComponent } from '../policy-number/policy-number.component';
import { CoveragesComponent } from '../coverages/coverages.component';
import { ValuablesComponent } from '../valuables/valuables.component';
import { DiscountsComponent } from '../discounts/discounts.component';
import { ContactPreferencesComponent } from '../contact-preference/contact-preference.component';

import { CardConfig } from './card-config.model';
import { FeesComponent } from '../fees/fees.component';
import { ClaimsComponent } from '../claims/claims.component';

export const CARD_CONFIGS: CardConfig[] = [
    {
        component: PolicyNumberComponent,
        name: 'policy-number',
        inputs: { isLoading: 'isDCPolicyLoaded' },
        visibleWhen: 'always',
        highlightKey: 'policy-number',
    },
    {
        component: InsuredProfileComponent,
        name: 'insured-profile',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed', isThirdParty: 'isThirdParty' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'always',
        highlightKey: 'Insured profile',
    },
    {
        component: LatestActivitiesComponent,
        name: 'latest-activities',
        inputs: {
            isLoaded: 'isLatestActivitiesLoaded',
            dcPolicyFailed: 'dcPolicyFailed',
            dcBillingFailed: 'dcBillingFailed',
        },
        outputs: { retry: 'retryLatestActivities' },
        visibleWhen: 'authenticated',
        highlightKey: 'Latest activities',
    },
    {
        component: TransactionsInformationComponent,
        name: 'transactions-information',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'authenticated',
        highlightKey: 'Transactions information',
    },
    {
        component: InboundOutboundCommsComponent,
        name: 'inbound-outbound-comms',
        inputs: { isCommLoaded: 'isCommLoaded', commFailed: 'commFailed' },
        outputs: { retry: 'retryComm' },
        visibleWhen: 'authenticated',
        highlightKey: 'Inbound / Outbound comms',
    },
    {
        component: RecentDocumentsComponent,
        name: 'recent-documents',
        inputs: { isLoaded: 'isDMSLoaded', dmsFailed: 'dmsFailed', isThirdParty: 'isThirdParty' },
        outputs: { retry: 'retryDMS' },
        visibleWhen: 'always',
        highlightKey: 'Recent documents',
    },
    {
        component: InspectionsComponent,
        name: 'inspections',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'authenticated',
        highlightKey: 'Inspections',
    },
    {
        component: MoratoriumComponent,
        name: 'moratorium',
        inputs: {},
        outputs: {},
        visibleWhen: 'authenticated',
        highlightKey: 'Moratorium activity',
    },
    {
        component: NotesComponent,
        name: 'notes',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'authenticated',
        highlightKey: 'Notes',
    },
    {
        component: PolicyGeneralInformationComponent,
        name: 'policy-general-information',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'always',
        highlightKey: 'Policy general information',
    },
    {
        component: PaymentInformationComponent,
        name: 'payment-information',
        inputs: { isDCBillingLoaded: 'isDCBillingLoaded', dcBillingFailed: 'dcBillingFailed' },
        outputs: { retry: 'retryDCBilling' },
        visibleWhen: 'always',
        highlightKey: 'Payment information',
    },
    {
        component: BillingInformationComponent,
        name: 'billing-information',
        inputs: { isDCBillingLoaded: 'isDCBillingLoaded', dcBillingFailed: 'dcBillingFailed', isThirdParty: 'isThirdParty' },
        outputs: { retry: 'retryDCBilling' },
        visibleWhen: 'always',
        highlightKey: 'Billing information',
    },
    {
        component: ContactPreferencesComponent,
        name: 'contact-preferences',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'authenticated',
        highlightKey: 'Contact preferences',
    },
    {
        component: CoveragesComponent,
        name: 'coverages',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'always',
        highlightKey: 'Coverages',
    },
    {
        component: ValuablesComponent,
        name: 'valuables',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'always',
        highlightKey: 'Valuables',
    },
    {
        component: DiscountsComponent,
        name: 'discounts',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'always',
        highlightKey: 'Discounts & Surcharges',
    },
    {
        component: FeesComponent,
        name: 'fees',
        inputs: { isDCPolicyLoaded: 'isDCPolicyLoaded', dcPolicyFailed: 'dcPolicyFailed' },
        outputs: { retry: 'retryDCPolicy' },
        visibleWhen: 'always',
        highlightKey: 'Fees',
    },
    {
        component: ClaimsComponent,
        name: 'claims',
        inputs: { isClaimsLoaded: 'isClaimsLoaded', claimsFailed: 'claimsFailed' },
        outputs: { retry: 'retryClaims' },
        visibleWhen: 'authenticated',
        highlightKey: 'Claims',
    },
];
